import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

// Component used to close a modal popup
// can not close a modal popup like a normal back page
@Component({
  standalone: true,
  imports: [CommonModule, IonicModule],
  selector: 'app-modal-back',
  templateUrl: './modal-back.component.html',
  styleUrls: ['./modal-back.component.scss'],
})
export class ModalBackComponent {
  /**
   * Icon name used in back button.
   */
  @Input() icon = 'chevron-back';

  /**
   * aria-label attribute to use on the icon.
   */
  @Input() ariaLabel = 'back';

  @Output() closed = new EventEmitter<void>();

  constructor(private modalCtrl: ModalController) {}

  /**
   * for close the modal popup
   */
  closeModal() {
    this.modalCtrl.dismiss();
    this.closed.emit();
  }
}
